import ScopeType from '@/shared/enums/ScopeType';
import ViewMode from '@/shared/enums/ViewMode';

/**
 * Sets the default scope when switching view modes.
 *
 * @param {String} viewMode
 *
 * @return {String}
 */
export default function defaultScope(viewMode) {
  switch (viewMode) {
    case ViewMode.INSIGHTS:
      return ScopeType.SUMMARY;
    default:
      return ScopeType.ACTIVITIES;
  }
}
